import { formatCustomDate } from "helpers/dateTools";

// IDs de tipos de movimiento de traspasos
export const TRANSFER_IDS = {
    TRASPASOS_F_SALIDA: "e4780a84-fa4e-4355-bf92-67c873275b8e",
    TRASPASOS_DE_SALIDA: "f03fe306-f19f-4f56-85c1-33b250c379ca",
};

export const isTransferMovement = (idGasMovement) => {
    const id = typeof idGasMovement === "object" ? idGasMovement?.id : idGasMovement;
    return [TRANSFER_IDS.TRASPASOS_F_SALIDA, TRANSFER_IDS.TRASPASOS_DE_SALIDA].includes(id);
};

export const initialValues = {
    inputValues: {
        idStation: null,
        idUnit: null,
        dateMovement: formatCustomDate(new Date(), "-"),
        idGasMovement: null,
        idNote: null,
        kilograms: 0,
        liters: 0,
        idUser: null,
        user: "",
        email: "",
        comment: "",
        type: "",
        unitsByType: [],
        movement: null,
        movementType: null,
        notesFoliosOpt: [],
        movGasOpt: [],
        idStationDestino: null,
        idStorageDestino: null,
    },
    required: {
        dateMovement:{
            required: true,
        },
        idStation: {
            required: true,
        },
        comment: {
            required: true,
        },
        type: {
            required: true,
        },
        idUnit: {
            required: true,
        },
        idNote: {
            required: true,
        },
        idGasMovement: {
            required: true,
        },
    }
};